// type actionType = 'csc' | 'message' | 'importAndExport' | 'vetting';
export interface ApplicationItemType {
  systemId: string;
  logo: string;
  textLogo: string;
  title: string;
  description?: string;
  dashboard: string;
}

export const ApplicationInfo: ApplicationItemType = {
  systemId: '100012',
  title: '阿里资产',
  logo: 'https://oss.elebuys.com/202506181515080005105620.png',
  textLogo: 'https://oss.elebuys.com/202506181515080005105620.png',
  description: '阿里资产',
  dashboard: '/dashboard', // 首页
};
